import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import de from "@/locales/de.json";
import en from "@/locales/en.json";

export const SUPPORTED_LOCALES = ["de", "en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

// init() returned eine Promise — wir feuern-und-vergessen. Wenn das Laden der
// Resourcen fehlschlägt, fällt i18next selbst auf fallbackLng zurück und logged
// in die Console; keine app-bremsende Fehlerbehandlung nötig.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: "de",
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: {
      escapeValue: false, // React eskapiert schon
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "strategify_locale",
    },
  });

export { i18n };
